import { z } from 'zod';
import { getAddress } from 'ethers';
import { ALL_CHAIN_IDS } from '../chains/index.js';
const evmAddressSchema = z
    .string()
    .refine((value) => {
    try {
        getAddress(value);
        return true;
    }
    catch {
        return false;
    }
}, 'Invalid EVM address (must be valid hex; checksum will be normalized)')
    .transform((value) => getAddress(value));
const chainIdSchema = z.enum(ALL_CHAIN_IDS);
const masterWalletsSchema = z
    .record(chainIdSchema, evmAddressSchema)
    .refine((record) => Object.keys(record).length > 0, 'At least one master wallet must be configured');
export const createMerchantSchema = z.object({
    name: z.string().min(1).max(120),
    masterWallets: masterWalletsSchema,
    webhookUrl: z.string().url().optional(),
    allowedOrigins: z.array(z.string().url()).max(50).optional(),
    contactEmail: z.string().email().max(320).optional(),
});
export const updateMerchantSchema = z
    .object({
    name: z.string().min(1).max(120).optional(),
    masterWallets: masterWalletsSchema.optional(),
    webhookUrl: z.string().url().nullable().optional(),
    allowedOrigins: z.array(z.string().url()).max(50).optional(),
    contactEmail: z.string().email().max(320).nullable().optional(),
})
    .refine((data) => Object.keys(data).length > 0, 'At least one field must be provided');
export const upsertUserSchema = z.object({
    idToken: z.string().min(1, 'idToken required'),
});
export { evmAddressSchema, chainIdSchema };
//# sourceMappingURL=index.js.map